
import { MDBCol, MDBRow } from "mdbreact";
import FormField from "../../../../../common/form/Form";
import { Button, Label, TextArea } from "abs-ui-components";
import { forwardRef, useEffect, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useParams } from "react-router";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { C1Column } from "../../FeuConstants";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";

const FeuConditinsOfExemption = forwardRef(({ exemptionConditionsData, refetchMonitoringData, dropdownData,vesselMstId }, ref) => {
    const { control, handleSubmit, reset, getValues, formState } = useFormContext();
    const savedValuesRef = useRef({});
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);
    const { dirtyFields } = formState;
    const isC1Dirty = !!(dirtyFields?.c1 && Object.keys(dirtyFields.c1).length > 0);

    useEffect(() => {
        if (exemptionConditionsData) {
            const cleanedValues = C1Column.reduce((acc, { name }) => {
                acc[name] = exemptionConditionsData?.[name] || "";
                return acc;
            }, {});
            reset(prev => ({ ...prev, c1: cleanedValues }));
            savedValuesRef.current = cleanedValues;
        }
    }, [exemptionConditionsData, reset]);

    const buildOptions = (source, firstLabel = "Select an option") => [
        { label: firstLabel, value: "" },
        ...(Array.isArray(source) ? source : []).map(item => ({
            label: item.value,
            value: item.code,
        })),
    ];

    const yesNoNotApplicableOptions = buildOptions(
        dropdownData?.yesNoNotApplicableOptions
    );

    const yesNoOptions = buildOptions(
        dropdownData?.yesNoOptions

    );

    AutoSave(ref, [], async () => {
        const currentValues = getValues("c1");
        const isChanged = Object.keys(currentValues || {}).some(
            key => currentValues[key] !== savedValuesRef.current?.[key]
        );
        if (!isC1Dirty || !isChanged) return;
        await onSubmit(true);
    });

    const onSubmit = async (isAuto = false) => {
        const formValues = getValues("c1");
        const payload = C1Column.reduce((acc, { name }) => {
            const value = formValues?.[name];
            acc[name] = value || "";
            return acc;
        }, {});
        try {
            const C1CondiitonsOfExemption = await callApi({
                method: "POST",
                url: API_ROUTES.C1(vesselMstId),
                data: payload,
            });
            if (C1CondiitonsOfExemption?.isSuccess) {
                emitToasterMsg("success", "Table C.1", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c12: formValues }));
                savedValuesRef.current = { ...formValues };
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.1", C1CondiitonsOfExemption?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.1", error.errorMessage);
        }
    };

    useEffect(() => {
        if (exemptionConditionsData) {
            reset(prev => ({ ...prev, c: exemptionConditionsData }));
        }
    }, [exemptionConditionsData, reset]);

    return (
        <form >
            <div className="C1-section-form mt-4">
                {C1Column.map(({ label, name, maxLength, type }, index) => (
                    <MDBRow className="align-items-center mb-3" key={index}>
                        <MDBCol md="4">
                            <Label name={label} bold />
                        </MDBCol>
                        <MDBCol md="4">
                            {type === "dropdown" ? (
                                <FormField
                                    name={`c1.${name}`}
                                    type="dropdown"
                                    options={
                                        name === "expectedVoyagesUnderScope" || name === "regultionCondition"
                                            ? yesNoOptions
                                            : name === "useOfDerogation"
                                                ? yesNoNotApplicableOptions
                                                : []
                                    }
                                />
                            ) : (
                                <Controller
                                    name={`c1.${name}`}
                                    control={control}
                                    render={({ field }) => (
                                        <TextArea
                                            id={`c1_${name}`}
                                            className="textarea-resize"
                                            value={field.value || ""}
                                            onChange={field.onChange}
                                            placeholder=""
                                            maxLength={maxLength}
                                            rows={1}
                                        />
                                    )}
                                />
                            )}
                        </MDBCol>
                    </MDBRow>
                ))}

                <div className="text-center">
                    <Button id="c1_save_btn"
                        disabled={!isC1Dirty}
                        onClick={async () => {
                            manualSaveTriggered.current = true;
                            await onSubmit(false);
                        }}
                    >
                        Save
                    </Button>
                </div>
            </div>
        </form>

    );


})

export default FeuConditinsOfExemption;